import { SVGPropsIcon } from 'src/types';

export const HeaderBurgerIcon = (props: SVGPropsIcon) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M19.1632 12.6429H4.83666C4.69053 12.6429 4.55037 12.5752 4.44703 12.4546C4.3437 12.334 4.28564 12.1705 4.28564 12C4.28564 11.8295 4.3437 11.666 4.44703 11.5455C4.55037 11.4249 4.69053 11.3572 4.83666 11.3572H19.1632C19.3093 11.3572 19.4495 11.4249 19.5528 11.5455C19.6562 11.666 19.7142 11.8295 19.7142 12C19.7142 12.1705 19.6562 12.334 19.5528 12.4546C19.4495 12.5752 19.3093 12.6429 19.1632 12.6429ZM19.7142 16.5C19.7142 16.3295 19.6562 16.166 19.5528 16.0455C19.4495 15.9249 19.3093 15.8572 19.1632 15.8572H4.83666C4.69053 15.8572 4.55037 15.9249 4.44703 16.0455C4.3437 16.166 4.28564 16.3295 4.28564 16.5C4.28564 16.6705 4.3437 16.834 4.44703 16.9546C4.55037 17.0752 4.69053 17.1429 4.83666 17.1429H19.1632C19.3093 17.1429 19.4495 17.0752 19.5528 16.9546C19.6562 16.834 19.7142 16.6705 19.7142 16.5ZM19.7142 7.50003C19.7142 7.32954 19.6562 7.16603 19.5528 7.04547C19.4495 6.92491 19.3093 6.85718 19.1632 6.85718H4.83666C4.69053 6.85718 4.55037 6.92491 4.44703 7.04547C4.3437 7.16603 4.28564 7.32954 4.28564 7.50003C4.28564 7.67053 4.3437 7.83404 4.44703 7.9546C4.55037 8.07516 4.69053 8.14289 4.83666 8.14289H19.1632C19.3093 8.14289 19.4495 8.07516 19.5528 7.9546C19.6562 7.83404 19.7142 7.67053 19.7142 7.50003Z"
        fill="#F8DFFF"
      />
    </svg>
  );
};
